import moment from 'moment';
import {
  DEFAULT_STAT_LIMIT
} from '../common/config';
import {
  Filter
} from '../common/filter';

class FilterDataService {
  constructor({
    CurrentFilterService,
    CurrentModelService,
    $q,
    $rootScope,
    $http,
    $timeout,
    $cookies,
    $httpParamSerializer,
    ErrorHandlerService,
    rx,
    isModalEditor,
  }) {
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentModelService = CurrentModelService;
    this.isModalEditor = isModalEditor;
    this.$q = $q;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.ErrorHandlerService = ErrorHandlerService;
    this.options = ErrorHandlerService.LayoutService.options;
    this.$cookies = $cookies;
    this.$httpParamSerializer = $httpParamSerializer;
    this.rx = rx;
    this.filter = null;
    this.$rootScope = $rootScope;
    this.actualFilter = null;
    this.filterData = null;
    this.loading = false;
    this.loadingMore = false;
    this.cancelled = false;
    this.cancelledMore = false;
    this.canceller = null;
    this.frameLoad = null;
    this.cancelSubject = new rx.Subject();
    this.loadMoreSubject = new rx.Subject();
    this.filterSubject = new rx.Subject();
    this.loadingSubject = new rx.Subject();
    this.loading$ = this.loadingSubject.asObservable();

    this.filterData$ = this.filterSubject.asObservable()
      .filter(filter => {
        this.currentFilterId = CurrentFilterService.filter ? CurrentFilterService.filter.id : 0;
        if (!this.CurrentModelService.cube) {
          console.error('model is not defined');
          return false;
        }
        return !!filter;
      })
      .flatMap(filter => this.checkFilterError(filter))
      .map(filter => {
        this.filter = filter;
        this.actualFilter = this.getActualFilter(filter);
        const params = this.actualFilter.buildQueryParams();
        if (this.CurrentFilterService.lastScreenshots) {
          params.lastScreenshotsTimeFrom = this.CurrentFilterService.lastScreenshots.timeFrom;
          params.lastScreenshotsEventTp = this.CurrentFilterService.lastScreenshots.eventTp ?
            this.CurrentFilterService.lastScreenshots.eventTp : '4';
        }
        this.initPage = this.initPage || 0;
        params.page = this.initPage;
        this.page = this.initPage;
        return {
          filter: this.actualFilter,
          url: this.getUrl(this.actualFilter),
          params: params,
        };
      })
      .distinctUntilChanged(null, (params1, params2) => {
        if (this.force) return false;
        if (!params1 || !params2) return true;
        const isParamsEq = angular.equals(params1.params, params2.params);
        if (params1.params.page == params2.params.page && !isParamsEq) this.page = 0;
        return !this.cancelled && params1 && params2 &&
          params1.url === params2.url && isParamsEq;
      })
      .filter(params => params)
      .switchMap((params) => {
        if (this.loading || this.loadingMore) {
          this.onCancel();
        }
        this.filterData = null;
        params.params.page = this.page;
        this.initPage = this.page;
        this.beforeLoad();
        const loadPromise = this.ErrorHandlerService.filterErrorMessage.text ?
          Promise.resolve({
            'count': 0,
            'object_list': [],
            'page': 0
          }) : this.load(params);
        this.loadingSubject.onNext(true);
        return rx.Observable.amb(
            this.cancelSubject.asObservable()
            .do(() => this.onCancel())
            .first(),
            rx.Observable.fromPromise(loadPromise)
            .do((data) => this.afterLoad(data))
            .catch((error) => {
              this.onError(error);
              this.error = error;
              return rx.Observable.of(null);
            }),
          )
          .flatMap(data => {
            this.loadingSubject.onNext(false);
            if (data === null) {
              return rx.Observable.of(data);
            }
            if (!this.filter.isExplore) {
              return rx.Observable.of(data);
            }
            return rx.Observable.of(data)
              .concat(this.loadMoreSubject.asObservable()
                .exhaustMap(() => rx.Observable.of(null).flatMap(() => {
                  if (this.isComplete) {
                    return rx.Observable.of(null);
                  }
                  this.page += 1;
                  const nextPageParams = {
                    filter: params.filter,
                    url: params.url,
                    params: Object.assign({}, params.params),
                  };
                  nextPageParams.params.page = this.page;
                  this.beforeLoad();
                  return rx.Observable.amb(
                    this.cancelSubject.asObservable()
                    .do(() => this.onCancel())
                    .first(),
                    rx.Observable.fromPromise(this.load(nextPageParams))
                    .do((data) => this.afterLoad(data))
                    .catch((error) => {
                      this.onError(error);
                      return rx.Observable.of(null);
                    }),
                  );
                }), ),
              );
          }, );
      })
      .share();
    this.subscription = this.filterData$
      .subscribe(
        () => {
          this.$rootScope.$evalAsync(() => {
            this.$timeout(() => {
              this.$rootScope.$root.$broadcast('factsLoaded');
            }, 10);
          });
        },
      );
  }

  checkFilterError(filter) {
    if (!filter) return Promise.resolve({});
    const promise = new Promise(resume => {
      return this.CurrentFilterService.getFilterError(filter)
        .then(filterError => {
          if (!filterError.error) {
            filterError.text = this.CurrentModelService.model.checkIsFilterCutsValueAllowed(filter);
            if (filterError.text) filterError.error = true;
          }
          this.setErrorMessage(filterError);
          if (filterError.text) {
            this.loading = false;
            this.loadingMore = false;
            this.canceller = null;
            this.frameLoad = null;
            return resume(filter);
          }
          resume(filter);
        });
    });
    return this.rx.Observable.fromPromise(promise);
  }

  setErrorMessage(message) {
    if (!this.ErrorHandlerService.filterErrorMessage) this.ErrorHandlerService.filterErrorMessage = {};
    // if (this.ErrorHandlerService.filterErrorMessage.source && this.ErrorHandlerService.filterErrorMessage.source !== 'filter-data') return;
    const errorMessage = this.ErrorHandlerService.filterErrorMessage;
    if (message.error || errorMessage.source != 'data-filter') {
      this.ErrorHandlerService.filterErrorMessage.text = message.text;
      this.ErrorHandlerService.filterErrorMessage.fields = message.fields;
      this.ErrorHandlerService.filterErrorMessage.error = message.error;
      this.ErrorHandlerService.filterErrorMessage.source = message.source;
    }
  }

  update(filter, force) {
    const result = this.filterData$.first().toPromise();
    this.force = force;
    this.filterSubject.onNext(filter);
    return result;
  }

  moreFacts() {
    this.loadMoreSubject.onNext(null);
  }

  load({
    filter,
    url,
    params
  }) {
    if (filter.isReports && !filter.isCard) {
      this.frameLoad = this.$q.defer();
      return this.frameLoad.promise;
    }

    if (url.startsWith('/analytics/facts') && !this.CurrentFilterService.PermissionService.fact) {
      return Promise.resolve({
        cells: []
      });
    }

    return this.$http.post(url, this.$httpParamSerializer(params), {
      headers: {
        'Accept': 'application/json;charset=utf-8',
        'X-CSRFToken': this.$cookies.get('csrftoken'),
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      timeout: this.canceller.promise,
    }).then(({
      data
    }) => data);
  }

  getActualFilter(filter) {
    const actualFilter = new Filter('Facts');
    actualFilter.copyFrom(filter);
    actualFilter.time_filter = this.options && this.options.timeRegistered && this.options.timeRegistered.value;
    if (!actualFilter.hasOwnTime && (!this.isModalEditor || !actualFilter.isAnalysis || 
      actualFilter.isEventRiver || !actualFilter.send_threshold ||
      !actualFilter.threshold_period || !actualFilter.threshold)) {
      actualFilter.timeFrom = this.CurrentFilterService.timeFrom;
      actualFilter.timeTo = this.CurrentFilterService.timeTo;
    }

    if (actualFilter.isExplore) {
      if (!actualFilter.hasOwnProperty('order') || actualFilter.order === 'record_count')
        actualFilter.order = 'local_time';
    } else if (actualFilter.isHeatmap || actualFilter.isEventRiver) {
      const timeTo = moment(new Date()) > moment(actualFilter.timeTo) ?
        moment(actualFilter.timeTo) : moment(new Date());
      let days = timeTo.diff(moment(actualFilter.timeFrom), 'days') + 1;
      if (days < 1) days = 1;
      actualFilter.days = days;
      let activity_dimension;
      if (!actualFilter.customLimit) actualFilter.limit = DEFAULT_STAT_LIMIT;

      if (days > 1) {
        if (actualFilter.isEventRiver) activity_dimension = 'agent_time@ymd:day';
        if (actualFilter.isHeatmap) activity_dimension = 'agent_time@ymdh:hour';
      } else {
        if (actualFilter.isEventRiver) activity_dimension = 'agent_time@ymdh:hour';
        if (actualFilter.isHeatmap) activity_dimension = 'agent_time@ymdhm:minute';
      }
      if (actualFilter.isEventRiver) {
        actualFilter.drilldown.push(activity_dimension);
        actualFilter.order = actualFilter.measure;
      } else {
        actualFilter.drilldown = [activity_dimension];
        actualFilter.setOrder(activity_dimension);
      }
    } else if (actualFilter.isChartArea || actualFilter.isRadar ||
      actualFilter.isChart || actualFilter.isTree) {
      actualFilter.order = actualFilter.measure;
      actualFilter.orderDir = 'desc';
      actualFilter.timePeriod = this.CurrentFilterService.timePeriod;
      if (!actualFilter.customLimit) actualFilter.limit = DEFAULT_STAT_LIMIT;
    } else if (actualFilter.isSummStat) {
      actualFilter.order = actualFilter.measure == 'total_elements' ? 'record_count' : actualFilter.measure;
      actualFilter.orderDir = 'desc';
      actualFilter.timePeriod = this.CurrentFilterService.timePeriod;
      if (!actualFilter.customLimit) actualFilter.limit = DEFAULT_STAT_LIMIT;
    } else if (actualFilter.isStat || actualFilter.isSummStat) {
      actualFilter.order = actualFilter.orders.map(e => e === 'measure' ? filter.measure : e);
      actualFilter.orderDir = actualFilter.orderDirs.slice();
      actualFilter.timePeriod = this.CurrentFilterService.timePeriod;
      if (!actualFilter.customLimit) actualFilter.limit = DEFAULT_STAT_LIMIT;
    } else if (actualFilter.isCardFilter) {
      actualFilter.order = actualFilter.measure;
      actualFilter.orderDir = 'desc';
      actualFilter.timePeriod = this.CurrentFilterService.timePeriod;
      if (!actualFilter.customLimit) actualFilter.limit = DEFAULT_STAT_LIMIT;
    } else if (actualFilter.isReports || actualFilter.isDashboard || actualFilter.isCard) {
      //
    } else {
      console.error('unknown filter mode');
    }
    return actualFilter;
  }

  getUrl(filter) {
    if (this.CurrentFilterService.lastScreenshots) {
      return '/analytics/last_screenshots/';
    } else if (filter.isExplore) {
      return '/analytics/facts/' + this.cube.name + '/';
    } else if (filter.isAnalysis) {
      return filter.skipStat ?
        '/analytics/values/' + this.cube.name + '/' :
        '/analytics/aggregate/' + this.cube.name + '/';
    } else if (filter.isCardFilter) {
      return '';
    } else if (filter.isReports) {
      return filter.url;
    } else if (filter.isDashboard || filter.isCard) {
      return '';
    }
    console.error('unknown filter mode');
  }

  formatDate(text) {
    return Filter.formatDate(new Date(text), 'dd MMM yyyy HH:mm');
  }

  get cube() {
    return this.CurrentModelService.cube;
  }

  cancel() {
    this.cancelSubject.onNext(null);
  }

  onCancel() {
    if (!this.loading && !this.loadingMore || !this.canceller) {
      console.error('nothing to cancel');
      return;
    }
    this.canceller.resolve('abort');
    this.canceller = null;
    this.loading = false;
    this.loadingMore = false;
    this.isComplete = false;
    this.frameLoad = null;
    if (this.page > 0) {
      this.page -= 1;
      this.cancelledMore = true;
    } else {
      this.cancelled = true;
    }
    this.$rootScope.$evalAsync(() => {});
  }

  beforeLoad() {
    if (this.loading || this.loadingMore || this.canceller) {
      console.error('load filter already in progress');
    }
    this.canceller = this.$q.defer();
    this.loadTime = null;
    this.loading = this.page === 0;
    this.loadingMore = this.page !== 0;
    this.cancelled = false;
    this.cancelledMore = false;
    this.isComplete = false;
    this.error = null;
    this.$rootScope.$evalAsync(() => {});
  }

  afterLoad(data) {
    if (!this.loading && !this.loadingMore) {
      console.error('load filter not in progress');
    }

    this.loading = false;
    this.loadingMore = false;
    this.canceller = null;
    this.frameLoad = null;
    const dataLength = (data && data.object_list && data.object_list.length) ? data.object_list.length : 0;
    if (this.page === this.initPage) {
      if (this.filter.isExplore) {
        const showRows = Math.round(window.innerHeight / 33);
        const showFactsLen = dataLength < showRows ? dataLength : showRows;
        for (let i = 0; i < showFactsLen; i++) {
          data.object_list[i].needToShowTD = true;
        }
      }
      if (this.filter.isExplore || this.CurrentFilterService.lastScreenshots) {
        this.isComplete = this.filter.customLimit || dataLength < this.filter.limit;
        this.filterData = data.object_list;
      } else {
        this.isComplete = true;
        this.filterData = data;
        if (this.filter.isAnalysis) {
          data.filter = this.actualFilter;
          if (data.filter.isStat && data.cells) {
            const measureValues = data.cells.map(e => e[data.filter.measure]);
            data.maxMeasure = Math.max.apply(null, measureValues);
          }
        } else if (this.filter.isCardFilter) {
          data.items = data.items || [];
          for (let i = 0; i < data.items.length; ++i) {
            const item = data.items[i];
            item['agent_account.last_report_time'] =
              this.formatDate(item['agent_account.last_report_time']);
            item['agent_account.last_activity_time'] =
              this.formatDate(item['agent_account.last_activity_time']);
          }
        }
      }
    } else {
      if (this.filter.isExplore) {
        this.isComplete = dataLength < this.filter.limit;
        this.filterData = this.filterData.concat(data.object_list);
      } else {
        this.isComplete = true;
        this.filterData = data;
      }
    }
    this.$timeout(() => {
      this.$rootScope.$broadcast('FilterDataLoaded');
    }, 10);
  }

  onError(error) {
    this.loading = false;
    this.loadingMore = false;
    this.canceller = null;
    this.isComplete = false;
    this.frameLoad = null;
    if (this.page > 0) {
      this.page -= 1;
    }
    this.ErrorHandlerService.handle(error);
    this.$rootScope.$evalAsync(() => {});
    console.error('load filter page', this.page, error);
  }
}

export function FilterDataFactory(
  CurrentFilterService,
  CurrentModelService,
  $q,
  $rootScope,
  $http,
  $timeout,
  $cookies,
  $httpParamSerializer,
  ErrorHandlerService,
  rx,
) {
  return (isModalEditor) =>
    new FilterDataService({
      CurrentFilterService,
      CurrentModelService,
      $q,
      $rootScope,
      $http,
      $timeout,
      $cookies,
      $httpParamSerializer,
      ErrorHandlerService,
      rx,
      isModalEditor,
    });
}



// WEBPACK FOOTER //
// ./src/core/filter-data.factory.js